import {
  IonButton,
  IonCol,
  IonFab,
  IonGrid,
  IonIcon,
  IonRow,
  IonText,
  isPlatform,
  IonLabel,
} from "@ionic/react";
import { chevronBackCircleOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setCreateStep } from "../../../store/massiveDocumentCreate";
import { ConfirmButton } from "./ConfirmButton";
import { CreateStatus } from "./CreateStatus";
import { UsersSelected } from "./UsersSelected";
import { UsersSelector } from "./UsersSelector";
import { selectShowCreateButton } from "../../../store/massiveDocumentCreate/selectors/selectShowCreateButton";
import { useParams } from "react-router-dom";
import { selectFormData } from "../../../store/massiveDocumentCreate/selectors/selectFormData";

export const DocumentCreateThirdStep = () => {
  const dispatch = useDispatch();
  const showButton = useSelector(selectShowCreateButton);
  const { userId }: { userId: string } = useParams();
  const { creationType } = useSelector(selectFormData);
  const tipoAcuerdo = creationType === "archivo"
    ? "Acuerdo masivo con archivo"
    : creationType === "plantilla"
      ? "Acuerdo masivo con plantilla"
      : "Acuerdo masivo";

  return (
    <>
      <section
        className={isPlatform("desktop") ? "ion-margin" : "ion-no-margin ion-margin-vertical"}
      >
        <IonText color="primary">
          <h2>Paso 2 de 2</h2>
        </IonText>
        <IonText color="primary">
          <h3>Seleccionar usuarios para {tipoAcuerdo}</h3>
        </IonText>
        <IonLabel slot="end" style={{ display: "flex", justifyContent: "end", paddingBottom: 20 }}>
          <IonButton
            color="secondary"
            disabled={!showButton}
            onClick={() => dispatch(setCreateStep(3))}
          >
            Preview de datos
          </IonButton>
        </IonLabel>
        <IonGrid class="ion-no-margin ion-no-padding">
          <IonRow>
            {userId != undefined ? null : (
              <IonCol
                sizeLg="6"
                sizeMd="12"
                sizeSm="12"
                sizeXs="12"
                style={{ paddingLeft: 0, paddingRight: 6 }}
              >
                <UsersSelector />
              </IonCol>
            )}
            <IonCol
              sizeLg={userId != undefined ? "12":"6"}
              sizeMd="12"
              sizeSm="12"
              sizeXs="12"
              style={{ paddingRight: 0, paddingLeft: 6 }}
            >
              <UsersSelected />
            </IonCol>
          </IonRow>
        </IonGrid>
      </section>
      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        <IonButton color="medium" size="large" onClick={() => dispatch(setCreateStep(1))}>
          <IonIcon icon={chevronBackCircleOutline} slot="start"></IonIcon>
          <span>Volver</span>
        </IonButton>
        <ConfirmButton />
      </IonFab>
      <CreateStatus />
    </>
  );
};
